import axios from "axios";

const apiUrl = `https://api.almasecret.msit-demo.fr`;

axios.defaults.withCredentials = true;
axios.defaults.baseURL = apiUrl;

export default axios;
